var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "basic-container",
    { staticClass: "navigation-config-page" },
    [
      _c("div", { staticClass: "page-header" }, [
        _c("div", { staticClass: "filter-container" }, [
          _c(
            "div",
            { staticClass: "filter-box" },
            [
              _c("el-input", {
                staticClass: "filter-item",
                attrs: { placeholder: "导航标题&备注", clearable: "" },
                on: { clear: _vm.returnFirstPage },
                model: {
                  value: _vm.filter.navgationTitle,
                  callback: function ($$v) {
                    _vm.$set(_vm.filter, "navgationTitle", $$v)
                  },
                  expression: "filter.navgationTitle",
                },
              }),
              _c(
                "el-select",
                {
                  staticClass: "filter-item",
                  attrs: {
                    filterable: "",
                    placeholder: "关联页面",
                    clearable: "",
                  },
                  on: { clear: _vm.returnFirstPage },
                  model: {
                    value: _vm.filter.pageTypeId,
                    callback: function ($$v) {
                      _vm.$set(_vm.filter, "pageTypeId", $$v)
                    },
                    expression: "filter.pageTypeId",
                  },
                },
                _vm._l(_vm.pageTypeOptions, function (item) {
                  return _c("el-option", {
                    key: item.id,
                    attrs: {
                      label: `(${item.id}) ${item.pageName}`,
                      value: item.id,
                    },
                  })
                }),
                1
              ),
              _c(
                "el-select",
                {
                  staticClass: "filter-item",
                  attrs: { filterable: "", placeholder: "状态", clearable: "" },
                  on: { clear: _vm.returnFirstPage },
                  model: {
                    value: _vm.filter.status,
                    callback: function ($$v) {
                      _vm.$set(_vm.filter, "status", $$v)
                    },
                    expression: "filter.status",
                  },
                },
                [
                  _c("el-option", { attrs: { label: "生效", value: 1 } }),
                  _c("el-option", { attrs: { label: "失效", value: 0 } }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "button-container" },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.returnFirstPage },
                },
                [_vm._v("搜索")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", plain: "" },
                  on: { click: _vm.addNavigation },
                },
                [_vm._v("新增")]
              ),
            ],
            1
          ),
        ]),
      ]),
      _c(
        "el-table",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.isLoading,
              expression: "isLoading",
            },
          ],
          staticClass: "config-table",
          staticStyle: { width: "100%" },
          attrs: { data: _vm.navigationList, border: "" },
        },
        [
          _c("el-table-column", {
            attrs: { prop: "id", label: "ID", fixed: "left" },
          }),
          _c("el-table-column", {
            attrs: { prop: "navgationTitle", label: "导航标题" },
          }),
          _c("el-table-column", {
            attrs: { label: "选中icon", width: "121" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [
                    row.onicon
                      ? _c("el-image", {
                          staticClass: "table-img",
                          attrs: {
                            src: row.onicon,
                            "preview-src-list": [row.onicon],
                            fit: "contain",
                          },
                        })
                      : _vm._e(),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "未选中icon", width: "121" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [
                    row.inicon
                      ? _c("el-image", {
                          staticClass: "table-img",
                          attrs: {
                            src: row.inicon,
                            "preview-src-list": [row.inicon],
                            fit: "contain",
                          },
                        })
                      : _vm._e(),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "关联页面" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [
                    _c("el-tag", [
                      _vm._v(_vm._s(`(${row.pageTypeId}) ${row.pageTypeName}`)),
                    ]),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { prop: "navgationId", label: "导航ID" },
          }),
          _c("el-table-column", { attrs: { prop: "remark", label: "备注" } }),
          _c("el-table-column", {
            attrs: { label: "状态" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [
                    _c("div", [_vm._v(_vm._s(_vm.statusMap[row.status]))]),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "操作", width: "200", fixed: "right" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "text", size: "small" },
                        on: {
                          click: function ($event) {
                            return _vm.editNavigation(row)
                          },
                        },
                      },
                      [_vm._v("编辑")]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "text", size: "small" },
                        on: {
                          click: function ($event) {
                            return _vm.deleteNavigation(row)
                          },
                        },
                      },
                      [_vm._v("删除")]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "text", size: "small" },
                        on: {
                          click: function ($event) {
                            return _vm.viewLog(row)
                          },
                        },
                      },
                      [_vm._v("日志")]
                    ),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "pagination-container" },
        [
          _c("el-pagination", {
            attrs: {
              background: "",
              layout: "total, sizes, prev, pager, next, jumper",
              "current-page": _vm.page,
              "page-size": _vm.limit,
              total: _vm.total,
            },
            on: {
              "size-change": _vm.handleSizeChange,
              "current-change": _vm.handleCurrentChange,
            },
          }),
        ],
        1
      ),
      _c("EditNavigationDialog", {
        attrs: {
          editType: _vm.editType,
          confirmCallback: _vm.refreshNavigationList,
          selectNavigation: _vm.selectNavigation,
        },
        model: {
          value: _vm.editNavigationDialogIsShow,
          callback: function ($$v) {
            _vm.editNavigationDialogIsShow = $$v
          },
          expression: "editNavigationDialogIsShow",
        },
      }),
      _c("LogDialog", {
        ref: "optionLog",
        attrs: { columnConfig: _vm.optionLogColumn, closeBtn: false },
        on: { reload: _vm.reloadLog },
        scopedSlots: _vm._u([
          {
            key: "type",
            fn: function ({ row }) {
              return [
                _c("div", [
                  row.type === 1 ? _c("span", [_vm._v("新增")]) : _vm._e(),
                  row.type === 2 ? _c("span", [_vm._v("修改")]) : _vm._e(),
                  row.type === 3 ? _c("span", [_vm._v("删除")]) : _vm._e(),
                  row.type === 4 ? _c("span", [_vm._v("提交审核")]) : _vm._e(),
                  row.type === 5 ? _c("span", [_vm._v("撤销审核")]) : _vm._e(),
                  row.type === 6 ? _c("span", [_vm._v("审核通过")]) : _vm._e(),
                  row.type === 7 ? _c("span", [_vm._v("审核拒绝")]) : _vm._e(),
                ]),
              ]
            },
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }